module.exports = __webpack_public_path__ + "static/media/Footer_Adornment_Mobile.41b35a7c.png";